import prefectureMap from 'utils/prefecture-map'
import { Form, Select } from 'components/common'

export interface PrefectureSelectProps {
  required: boolean
  value?: string
  defaultValue?: string
}

const options = Object.entries(prefectureMap).map(([key, value]) => (
  <Select.Option key={key} value={key}>
    {value}
  </Select.Option>
))

export const PrefectureSelect = ({
  required,
  value,
  defaultValue,
}: PrefectureSelectProps): JSX.Element => {
  return (
    <>
      <Form.Item
        name={'prefectureCode'}
        label="都道府県"
        labelCol={{ span: 24 }}
        initialValue={defaultValue}
        rules={[
          {
            required,
          },
        ]}
      >
        <Select
          value={value}
          style={{ width: 323.5 }}
          placeholder="選択してください"
        >
          {options}
        </Select>
      </Form.Item>
    </>
  )
}
